<!-- fraude-virement-alerte-modal.component.html -->
<div class="fraude-virement-alerte-modal-container">
    <h2 class="fraude-virement-alerte-modal-title">PRÉVENTION CONTRE LA FRAUDE</h2>
    <div class="fraude-virement-alerte-modal-content">
      <p>
        Nous attirons votre attention sur l'actuelle augmentation des tentatives de fraudes au moyen d'un RIB falsifié aux fins d'opérer un détournement de fonds vers un autre compte bancaire que celui du bénéficiaire, sans possibilité de récupération des fonds.
      </p>
      <p>
        La technique utilisée repose sur le piratage de la messagerie électronique du cabinet ou de son client destinataire du virement, opération qui permet de substituer de fausses coordonnées bancaires à celles du client.
      </p>
      <p>
        Toute instruction de virement à effectuer sur la base d'un RIB ou document équivalent reçu par message électronique, comme toute demande dématérialisée de modification des coordonnées du compte bancaire du destinataire des fonds, doit impérativement être précédée d'une vérification <strong>téléphonique</strong> des coordonnées du compte bancaire à créditer.
      </p>
      <p>
        Nous vous rappelons que seul votre cabinet est en mesure d'effectuer cette vérification auprès de votre client.
      </p>
      <div class="custom-checkbox-group">
        <label for="field-fraude-certif" class="custom-checkbox">
          <input id="field-fraude-certif" type="checkbox" [(ngModel)]="isCertified" />
          <span class="label-text">En conséquence, je certifie l'authenticité des indications figurant sur le RIB annexé à mon instruction</span>
        </label>
      </div>
    </div>

    <div class="modal-footer">
	    
      <button id="btn-cancel" aria-label="Bouton Fermer Popin" type="button" class="btn btn-secondary" (click)="onClose()">
        <i class="far fa-times"></i>
      
        {{ 'Actions.Cancel' | translate }}
      </button>
      
      <button id="btn-confirm" aria-label="Bouton je confirme" type="button" class="btn btn-primary" [disabled]="!isCertified" (click)="onConfirm()">
        {{ 'Actions.ConfirmFraude' | translate }}
      </button>

    </div>
  </div>
  